import { getDeviceType } from './device';
import * as loader from './loader';
import { init } from './init';
import { openChat, open } from './open';
import { close } from './close';
import { localStorage, sessionStorage, Cookies } from './storage';
import { sendEvent } from './analytics';
import Logger from './logger';

window.WC = {
    ...(window.WC && {
        ...window.WC
    }),
    version: () => {
        return process.env.WC_VERSION;
    },
    _loader: loader,
    _localStorage: localStorage,
    _sessionStorage: sessionStorage,
    _cookies: Cookies,
    _debug: false,
    init: init,
    config: null,
    chatProvider: 'Closer',
    device: getDeviceType(),
    sendEvent: sendEvent,
    openChat: openChat,
    open: open,
    close: close
};

document.addEventListener('LoadChat', (event) => {
    Logger.log('setting chat provider to', event.detail);
    window.WC.chatProvider = event.detail;
});

document.addEventListener('WCBaseDebugOn', () => {
    window.WC._debug = true;
    Logger.log('debug on, WC version:', window.WC.version());
});

document.dispatchEvent(new CustomEvent('WCBaseLoaded'));

if (window._openChatParams) {
    window.WC.openChat(window._openChatParams);
    window._openChatParams = null;
}

// setVariable();
// setEvents();
